<template>
    <section class="internal-page">
        <internal-page-header
            eyebrow="Publicação"
            :title="newsData ? newsData.title : 'Atualizações e notícias'"
            back-to="/categoria/noticias"
            back-label="Todas as publicações"
        />
        <div class="internal-content article-content">
            <page-state
                v-if="loading || error"
                :loading="loading"
                :error="error"
                @retry="loadNewsData"
            />
            <article v-else-if="newsData">
                <p v-if="newsData.created_at" class="article-date">
                    Publicado em {{ $moment(newsData.created_at).format('DD/MM/YYYY') }}
                </p>
                <v-img
                    v-if="newsData.cover_image_url"
                    :src="newsData.cover_image_url"
                    max-height="480"
                    class="article-cover"
                />
                <div class="internal-rich-text" v-html="newsData.content"></div>
                <router-link class="article-back" to="/categoria/noticias"
                    ><v-icon size="18">mdi-arrow-left</v-icon> Todas as publicações</router-link
                >
            </article>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
export default {
    name: 'FullNewsPage',
    data: () => ({ newsData: null, loading: true, error: false }),
    created() {
        this.loadNewsData();
    },
    methods: {
        async loadNewsData() {
            this.loading = true;
            this.error = false;
            try {
                const response = await axios.get(`/api/posts/${this.$route.params.id}`);
                this.newsData = response.data.content.data || response.data.content;
            } catch (error) {
                this.error = true;
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
<style scoped>
.article-content {
    max-width: 860px;
}
.article-date {
    color: var(--pbb-muted);
    font-size: 13px;
    margin-bottom: 24px;
}
.article-cover {
    border-radius: 8px;
    margin-bottom: 40px;
}
.article-back {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding-top: 30px;
    margin-top: 32px;
    border-top: 1px solid #dedbd4;
    text-decoration: none;
}
</style>
